import format from 'date-fns/format';
export const todaysDate = format(new Date(), 'dd.MM.yyyy');
